import React from 'react'
import { Tab, Tabs } from '@mui/material'
import {
    DirectionsCar as DirectionsCarIcon,
    LocalOffer as LocalOfferIcon,
    Layers as LayersIcon,
    Contacts as ContactsIcon,
    Business as BusinessIcon,
    FactCheck as FactCheckIcon,
} from '@mui/icons-material'
import { Link, useLocation } from 'react-router-dom'
import { useIsDesktop } from '@edge/spark/ui-mui'

const searchRouteList = [
    { path: '/', label: 'Format', TabIcon: LayersIcon },
    { path: '/vehicle', label: 'Vehicle Filter', TabIcon: DirectionsCarIcon },
    { path: '/sale', label: 'Sale Filter', TabIcon: LocalOfferIcon },
    { path: '/company', label: 'Company Filter', TabIcon: BusinessIcon },
    { path: '/workflows', label: 'Workflows', TabIcon: FactCheckIcon },
]

const contactRouteList = [
    { path: '/', label: 'Format', TabIcon: LayersIcon },
    { path: '/contact', label: 'Contact Filter', TabIcon: ContactsIcon },
]

interface Props {
    isContactCard: boolean
}

export const TabSwitcher: React.VFC<Props> = ({ isContactCard }: Props) => {
    const location = useLocation()
    const matches = useIsDesktop()
    const routeList = isContactCard ? contactRouteList : searchRouteList
    const value = location.pathname || 'Format'
    const variant = matches ? 'standard' : 'scrollable'
    const centered = !!matches

    return (
        <Tabs centered={centered} value={value} variant={variant} sx={{ color: 'blue' }}>
            {routeList.map((r) => (
                <Tab
                    key={r.path}
                    value={r.path}
                    icon={<r.TabIcon />}
                    label={r.label}
                    to={r.path}
                    component={Link}
                    sx={{
                        width: '1px',
                        minWidth: 1 / routeList.length,
                        px: 1,
                        fontSize: { xs: 8, sm: 12, md: 14 },
                    }}
                />
            ))}
        </Tabs>
    )
}

export default TabSwitcher
